<!-- 朋友圈SOP -->
<template>
  <div>
    <div class="head-title">朋友圈SOP</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、设置朋友圈SOP提醒规则。<a class="help-link" href="http://www.weijub.com/index/index/news_detail?id=138" target="_blank"
              rel="noopener noreferrer">使用教程</a>
          </p>
          <p>
            2、创建不同朋友圈SOP规则和周期，客户朋友圈、企业圈、微信朋友圈均可设置。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <nav class="navbar">
        <div class="nav-l">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd">新建朋友圈SOP</el-button>
          <el-button style="margin-left: 2.4rem" type="danger" icon="el-icon-delete" @click="onDels">批量删除</el-button>
        </div>
        <div class="nav-r">
          <span style="width: 27.0rem; display: inline-flex" @click.stop="onSelectPerson">
            <el-input v-model="person.name" placeholder="选择监督人" suffix-icon="el-icon-arrow-down" @change="clearD">
            </el-input>
          </span>
          <el-input style="width: 35rem; margin: 0 0 0 2rem" v-model="q" placeholder="请输入规则名称搜索"            prefix-icon="el-icon-search" clearable="" @change="getList">
            <el-button type="primary" slot="append" @click="getList">查询</el-button>
          </el-input>
          
        </div>
      </nav>
      <div class="main">
        <div class="table">
          <el-table :data="list" v-loading="tableLoading" border=""  @selection-change="handleSelectionChange"
            style="width: 100%; margin-top: 2.0rem">
            <el-table-column type="selection" width="40"> </el-table-column>
            <el-table-column prop="name" label="规则名称" style="width:12.5%"> </el-table-column>
            <el-table-column prop="period_name" label="SOP周期" style="width:12.5%">
            </el-table-column>
            <el-table-column prop="check_userid_name" label="监督人" style="width:12.5%">
            </el-table-column>
            <el-table-column prop="userid_name" label="执行人" style="width:12.5%">
              <template slot-scope="scope">
                <div>
                  <el-tag size="mini" style="margin: .2rem" v-for="i in scope.row.userid_name" :key="i">{{ i }}</el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status_name" label="状态" style="width:12.5%">
              <template slot-scope="scope">
                <template>
                  <span :style="{
                    color: scope.row.status == 1 ? '#67C23A' : '#F56C6C',
                  }">
                    {{ scope.row.status_name }}
                  </span>
                </template>
              </template>
            </el-table-column>
            <el-table-column prop="author" label="创建人" style="width:12.5%"> </el-table-column>
            <el-table-column prop="createtime" label="创建时间" style="width:12.5%">
            </el-table-column>
            <el-table-column label="操作"  width="200" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="onDetail(scope.row)">
                  编辑
                </el-button>
                <el-button @click="onDel(scope.row)" size="mini" type="text" style="color:#f00000 !important">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
              :page-sizes="[10, 20, 50, 100]" :auto-scroll="false" @pagination="getList" />
          </div>
        </div>
      </div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "friendSop",
  components: {
    rightPeople
  },
  data() {
    return {
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },
      q: "",
      person: {},
      module: "",
      multipleSelection: [],
      checkbox: false,
      tableLoading: true,
    };
  },

  computed: {},

  mounted() {
    this.getList();
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelect(person) {
      this.person = person;
      this.getList();
    },
    onSelectPerson() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    async getList() {
      const { data: res } = await this.axios({
        url: "/crm/CircleFriendsSop/getList",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          name: this.q,
          check_userid: this.person.userid,
          page: this.listQuery.page,
          number_page: this.listQuery.limit,
        }),
      });
      this.tableLoading = false;
      if (res.code == 1) {
        const d = res.data;
        this.list = d.data;
        this.total = d.total;
      }
    },
    onAdd() {
      this.$router.push({
        name: "friendSopDetail",
      });
    },
    async onDetail(row) {
      this.$router.push({
        name: "friendSopDetail",
        query: {
          id: row.id,
        },
      });
    },
    onDels() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const ids = this.multipleSelection.map((i) => i.id);
            this.del(String(ids));
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message("请选择您要删除的数据");
      }
    },
    onDel(row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(row.id);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async del(id) {
      const { data: res } = await this.axios({
        url: "/crm/CircleFriendsSop/del",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id,
        }),
      });
      if (res.code == 1) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getList();
      } else if (res.code == 0) {
        this.$message.error(res.msg);
      }
    },
    clearD() {
      if (this.person.name == "") {
        this.person.userid = "";
      }
      this.getList();
    },
  },
};
</script>
<style lang="scss"  scoped>
.nav-r {
  display: flex;
}
</style>
